/**
 * custom-easify-tpo.js
 * -------------------------------------------------------
 * CUSTOM: Easify TPO switch UI enhancement
 *
 * Source: layout/theme.liquid inline <script> block (~lines 472–543)
 *
 * Replaces the default Easify TPO toggle label with a custom
 * layout (title + price side by side). Uses MutationObserver so
 * it handles switches injected asynchronously by the Easify app.
 * -------------------------------------------------------
 */

function handleSwitch(container) {
  if (container.classList.contains('customized')) return;

  const img      = container.querySelector('img');
  const label    = container.querySelector('.form__label');
  const switchEl = container.querySelector('.tpo_switch');

  if (!label) return;

  const priceSpan = label.querySelector('span');
  let priceText   = '';

  if (priceSpan) {
    priceText = priceSpan.innerText
      .replace(/\+/g, '')
      .replace(/[()]/g, '')
      .replace(/[\s ]+/g, '')
      .replace(/\.00(?=\D*$)/, '')
      .trim();

    priceSpan.remove();
  }

  const content      = document.createElement('div');
  content.className  = 'custom-content';

  const title       = document.createElement('div');
  title.className   = 'title';
  title.innerText   = label.innerText.trim();

  const price       = document.createElement('div');
  price.className   = 'price';
  price.innerText   = priceText;

  content.appendChild(title);
  content.appendChild(price);

  container.innerHTML = '';
  if (img)      container.appendChild(img);
  container.appendChild(content);
  if (switchEl) container.appendChild(switchEl);

  container.classList.add('customized');

  const optionContainer = container.closest('.tpo_option-container');
  if (!optionContainer) return;

  const labelWrapper   = optionContainer.querySelector('.tpo_option-label');
  const labelContainer = optionContainer.querySelector('.tpo_option-label-container');
  const imgEl          = optionContainer.querySelector('img');

  if (labelWrapper && labelContainer && imgEl && !optionContainer.classList.contains('label-moved')) {
    labelWrapper.removeChild(labelContainer);
    optionContainer.insertBefore(labelContainer, imgEl);
    optionContainer.classList.add('label-moved');
  }
}

// Handle switches already in the DOM
document.querySelectorAll('.tpo_switch-container').forEach(handleSwitch);

// Handle switches injected asynchronously by the Easify app
const observer = new MutationObserver((mutations) => {
  mutations.forEach(() => {
    document.querySelectorAll('.tpo_switch-container').forEach(handleSwitch);
  });
});

observer.observe(document.body, { childList: true, subtree: true });
